module.exports = __webpack_public_path__ + "static/CPO-14f64be3785a136862bc5ff437f5ac1e.png";